import loadingIcon from '../assets/images/loading.svg';

const LoadingButton = ({ isLoading, className }) => {
  return isLoading ? <img src={loadingIcon} alt="Loading" className={className} /> : null;
};

export default LoadingButton;
